import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AppToastContainer = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      theme="dark"
      transition={Bounce}
      toastStyle={{
        backgroundColor: "#123D6C",
        color: "white",
      }}
      progressStyle={{
        background: "white",
      }}
    />
  );
};

export default AppToastContainer;
